import { Flex, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { CopyIcon } from '@udacity/chakra-uds-icons';
import { useAppToast } from 'app/common/hooks/use-app-toast';
import { copyToClipboard } from 'app/helpers/string-helper';
import { MeetingUser } from 'app/types/uconnect';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  learner: MeetingUser;
};

export const LearnerNameCell: React.FC<Props> = ({ learner }) => {
  const { t } = useTranslation();
  const toast = useAppToast();

  const name = `${learner.user?.firstName ?? ''} ${learner.user?.lastName ?? ''}`.trim();
  const email = learner.user?.email;

  const handleCopyEmail = async () => {
    if (!email) return;
    const copied = await copyToClipboard(email);
    toast({
      variant: copied ? 'success' : 'error',
      description: copied ? t('connect.emailCopied') : t('error.anErrorOccurred'),
    });
  };

  return (
    <Flex alignItems="center" gap={1}>
      <Tooltip label={email}>
        <Text>{name}</Text>
      </Tooltip>
      {email && (
        <Tooltip label={t('connect.copyEmail')}>
          <IconButton
            aria-label={t('connect.copyEmail')}
            icon={<CopyIcon h={4} w={4} />}
            size="xs"
            variant="ghost"
            onClick={handleCopyEmail}
          />
        </Tooltip>
      )}
    </Flex>
  );
};
